import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Usuario} from "../../models/usuario";
import {ValidatorService} from "../../core/services/validator.service";
import {UsuarioService} from "../../services/usuario.service";
import {MessageService} from "../../core/services/message.service";
import {NgxSpinnerService} from "ngx-spinner";
import {ActivatedRoute, Router} from "@angular/router";
import {LoginService} from "../../services/login.service";
import {Perfil} from "../../models/perfil";
import {PerfilService} from "../../services/perfil.service";
import {Login} from "../../models/login";
import {Estado} from "../../models/estado";
import {Municipio} from "../../models/municipio";
import {MunicipioService} from "../../services/municipio.service";
import {EstadoService} from "../../services/estado.service";

@Component({
    selector: 'app-usuario',
    templateUrl: './usuario.component.html',
    styleUrls: ['./usuario.component.scss']
})
export class UsuarioComponent implements OnInit {

    private usuario: Usuario;
    public perfis: Array<Perfil> = [];
    public form: FormGroup;
    public estados: Array<Estado>;
    public municipios: Array<Municipio>;

    constructor(private usuarioService: UsuarioService,
                private perfilService: PerfilService,
                private loginService: LoginService,
                private messageService: MessageService,
                private loadingService: NgxSpinnerService,
                private router: Router,
                private municipioService: MunicipioService,
                private estadoService: EstadoService,
                private validator: ValidatorService,
                private route: ActivatedRoute) {

    }

    ngOnInit() {
        let login: Login = this.loginService.getAuth();
        let url: string;
        if (login) {
            if (login.perfil != Perfil.ADMINISTRADOR) {
                url = "/plano";
                this.router.navigateByUrl(url);
            }
        } else {
            url = "/login";
            this.router.navigateByUrl(url);
        }

        this.usuario = new Usuario();
        this.usuario.flg_externo = false;
        this.form = new FormGroup({
            cod_usuario: new FormControl(this.usuario.cod_usuario, []),
            txt_nome: new FormControl(this.usuario.txt_nome, []),
            num_cpf: new FormControl(this.usuario.num_cpf, [
                Validators.required,
                ValidatorService.cpf
            ]),
            cod_perfil: new FormControl(this.usuario.cod_perfil, [
                Validators.required,
            ]),
            num_telefone: new FormControl(this.usuario.num_telefone, [
                Validators.required,
                ValidatorService.telefone
            ]),
            txt_cargo: new FormControl(this.usuario.txt_cargo, [
                Validators.required
            ]),
            txt_orgao: new FormControl(this.usuario.txt_orgao, [
                Validators.required
            ]),
            txt_unidade: new FormControl(this.usuario.txt_unidade, [
                Validators.required
            ]),
            txt_situacao: new FormControl(this.usuario.txt_situacao, [
                Validators.required
            ]),
            txt_email: new FormControl(this.usuario.txt_email, [
                Validators.required,
                Validators.email,
            ]),
            uf: new FormControl(null, [
                Validators.required
            ]),
            cod_municipio: new FormControl(null, [
                Validators.required
            ]),
            num_cnpj: new FormControl(null, [
                Validators.required,
                ValidatorService.cnpj
            ], [this.validator.existingCnpjValidator()]),
            txt_nome_prefeito: new FormControl(null, [
                Validators.required
            ]),
            flg_externo: new FormControl(this.usuario.flg_externo, [])
        });
        let id: number = this.route.snapshot.params.id;
        if (id) {
            this.carregarUsuario(id);
        }
        this.carregarPerfis();
        this.carregarEstados();
    }

    carregarUsuario(cod_usuario: number): void {
        this.loadingService.show();
        this.usuarioService.findById(cod_usuario).subscribe((usuario: Usuario) => {
            this.loadingService.hide();
            this.usuario = usuario;
            this.estados = [];

            this.municipios = [];
            this.estadoService.listAll().subscribe((estados: Array<Estado>) => {
                this.estados = estados;
            });

            this.municipioService.listAll(this.usuario.txt_sigla_uf).subscribe((municipios: Array<Municipio>) => {
                this.municipios = municipios;
            });
            this.form.patchValue({
                cod_usuario: this.usuario.cod_usuario,
                cod_perfil: this.usuario.cod_perfil,
                txt_nome: this.usuario.txt_nome,
                num_cpf: this.usuario.num_cpf,
                num_telefone: this.usuario.num_telefone,
                txt_cargo: this.usuario.txt_cargo,
                txt_orgao: this.usuario.txt_orgao,
                txt_unidade: this.usuario.txt_unidade,
                txt_email: this.usuario.txt_email,
                txt_situacao: this.usuario.txt_situacao,
                flg_externo: this.usuario.flg_externo,
                txt_nome_prefeito: this.usuario.txt_nome_prefeito,
                uf: this.usuario.txt_sigla_uf,
                cod_municipio: this.usuario.cod_municipio,
                num_cnpj: this.usuario.num_cnpj,
            });
        }, (error) => {
            this.loadingService.hide();
            this.messageService.showResponseError(error);
        });
    }

    carregarEstados(): void {
        this.loadingService.show();
        this.estados = [];
        this.estadoService.listAll().subscribe((estados: Array<Estado>) => {
            this.estados = estados;
            this.loadingService.hide();
        }, () => {
            this.loadingService.hide();
        });
        this.form.patchValue({
            cod_municipio: null
        });
    }

    carregarMunicipios(uf: string): void {
        this.municipios = [];
        if (uf) {
            this.loadingService.show();
            this.municipioService.listAll(uf).subscribe((municipios: Array<Municipio>) => {
                this.municipios = municipios;
                this.loadingService.hide();
            }, () => {
                this.loadingService.hide();
            });
        }
    }

    carregarPerfis(): void {
        this.loadingService.show();
        this.perfilService.listAll().subscribe((perfis: Array<Perfil>) => {
            this.loadingService.hide();
            this.perfis = perfis;
        }, (error) => {
            this.loadingService.hide();
            this.messageService.showResponseError(error);
        });
    }

    save(): void {
        this.form.markAsTouched();
        if (this.form.valid) {
            this.loadingService.show();
            let form = this.form.value as Usuario;
            this.usuarioService.save(form).subscribe((data: any) => {
                this.loadingService.hide();
                if (form.cod_usuario) {
                    this.messageService.showSuccess("Gestor alterado com sucesso");
                } else {
                    this.messageService.showSuccess(data.message);
                }
                this.router.navigateByUrl("usuarios");
            }, (error) => {
                this.loadingService.hide();
                this.messageService.showResponseError(error);
            });
        }
    }

}
